module.exports = __webpack_public_path__ + "img/first-timers.8bae9c3b.svg";